import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pc5004',
    ecrans: ['00-2']
});

